import Drawer, { DrawerContext } from "./drawer";
import DrawerBody from "./drawerBody";
import DrawerFooter from "./drawerFooter";
import DrawerGroup from "./drawerGroup";
import DrawerHeader from "./drawerHeader";
import DrawerItem from "./drawerItem";
import DrawerLink from "./drawerLink";
import DrawerSection from "./drawerSection";

export * from "./drawer";
export * from "./drawerBody";
export * from "./drawerFooter";
export * from "./drawerGroup";
export * from "./drawerHeader";
export * from "./drawerItem";
export * from "./drawerLink";
export * from "./drawerSection";

export default Object.assign(Drawer, {
  Group: DrawerGroup,
  Item: DrawerItem,
  Link: DrawerLink,
  Section: DrawerSection,
  Header: DrawerHeader,
  Body: DrawerBody,
  Footer: DrawerFooter,
  Context: DrawerContext,
});
